import type { IsoDateTime } from '@miyuki/types';

/** Puerto de tiempo: permite tests deterministas sin congelar el reloj global. */
export interface Clock {
  now(): IsoDateTime;
}

export const systemClock: Clock = {
  now: () => new Date().toISOString() as IsoDateTime,
};

export function fixedClock(isoDate: string): Clock {
  return { now: () => isoDate as IsoDateTime };
}
